// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"city-14"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M16 4.6L12 3L8 4.6V21H16V4.6Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2"},"nodeName":"g","children":[{"attributes":{"fill":"transparent","d":"M22 21V9H16V21H22Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"transparent","d":"M2 21H8V9H2V21Z"},"nodeName":"path","children":[]}]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 21V16M22 9V21H16V9H22ZM8 21H2V9H8V21ZM12 7.99805H12.0039V8.00195H12V7.99805Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M16 5.1V21H8V5.1M17 5L12 3L7 5","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-city-14')
export default class City14Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-14',
    }
  }
}
